import Swal from "sweetalert2";

export class AlertService {
    defaultWarningInfoSwalSettings = {
        icon: "warning",
        showCancelButton: false,
    };

    showSwal(title, text) {
        return Swal.fire({title, text, ...this.defaultWarningInfoSwalSettings});
    }

    showAdvancePaymentsHasDifferentContractSeal() {
        Swal.fire({
            title: '',
            text: $.i18n._("all_selected_advance_invoices_must_be_in_the_same_contract"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }
    showSelectedIdGreatherThanEditedDocument() {
        Swal.fire({
            title: '',
            text: $.i18n._("cant_connect_advance_payment_was_added_or_corrected_after_add_edited_invoice"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }
    showNotCompletedKsefAlert() {
        Swal.fire({
            title: '',
            text: $.i18n._("advance_invoice_has_not_complete_ksef_sending_status"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }
    showNotCompletedKsefAlert2() {
        Swal.fire({
            title: '',
            text: $.i18n._("advance_invoice_has_not_complete_ksef_sending_status_2"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showDocumentContainForeignVatRatesSwal() {
        return Swal.fire({
            title: $.i18n._("save_not_allowed"),
            text: $.i18n._("it_is_not_possible_to_issue_a_pl_own_invoice_for_a_receipt_containing_foreign_vat_rates"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showValidationUnexpectedErrorSwal() {
        return Swal.fire({
            title: $.i18n._("error"),
            text: $.i18n._("an_unexpected_error_has_occurred"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showSaveNotAllowedSwal() {
        return Swal.fire({
            title: $.i18n._("save_not_allowed"),
            text: $.i18n._("check_visible_warnings_and_fix_errors"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }
    showSaveNotAllowedKsefImportSwal() {
        return Swal.fire({
            title: $.i18n._("save_not_allowed"),
            text: $.i18n._("ksef_import_not_success_can_be_saved_as_draft"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showDocumentLimitSwal(message = "") {
        return Swal.fire({
            title: $.i18n._("save_not_allowed"),
            text: message,
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showDocumentInClosedGroupSwal() {
        return Swal.fire({
            title: $.i18n._("save_not_allowed"),
            text: $.i18n._('document_cannot_be_saved_as_it_would_cause_changes_to_the_closed_cash_report'),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showDocumentVatRatesInvalid() {
        return Swal.fire({
            text: $.i18n._('cannot_attach_documents_to_contract_vat_rate_mismatch'),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showDocumentSaveAsRejectedSwal(isForeign = false) {
        return Swal.fire({
            title: $.i18n._(isForeign ? "save_as_rejected_?" : "save_as_cancelled_?"),
            text: $.i18n._(isForeign
                ? "are_you_sure_you_want_to_save_the_document_as_rejected_?"
                : "are_you_sure_you_want_to_save_the_document_as_cancelled_?",
            ),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            confirmButtonText: $.i18n._("save"),
            cancelButtonText: $.i18n._("cancel"),
        });
    }

    showRelatedDocumentsSwal() {
        return Swal.fire({
            title: '',
            text: $.i18n._("related_document_swal_alert"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            confirmButtonText: $.i18n._("confirm"),
            cancelButtonText: $.i18n._("cancel"),
        });
    }

    showDocumentSaveInCashRegisterSwal() {
        return Swal.fire({
            title: $.i18n._("edit_operation_group_warning"),
            width: 600,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: $.i18n._("cancel"),
            showDenyButton: true,
            denyButtonColor: "#495966",
            denyButtonText: $.i18n._("edit_operation_group"),
            confirmButtonColor: "#28a745",
            confirmButtonText: $.i18n._("save"),
        });
    }

    showConfirmGenerateDuplicateLockEditSwal() {
        return Swal.fire({
            title: $.i18n._("generating_a_duplicate_is_only_possible_for_documents_locked_for_editing"),
            width: 600,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: $.i18n._("cancel"),
            confirmButtonColor: "#28a745",
            confirmButtonText: $.i18n._("save"),
        });
    };

    showContractUpdateSwal() {
        return Swal.fire({
            title: '',
            text: $.i18n._("updating_contract_data_will_reset_all_fields_in_the_goods_services_box"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            confirmButtonText: $.i18n._("ok"),
            cancelButtonText: $.i18n._("cancel"),
        });
    }

    showDeleteConnectionSwal() {
        return Swal.fire({
            title: $.i18n._('delete_connection'),
            text: $.i18n._("data_change_will_trigger_deletion_of_payment_allocations"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            confirmButtonText: $.i18n._("ok"),
            cancelButtonText: $.i18n._("cancel"),
        });
    }

    showCantSaveNameAliasContractorNotSelected() {
        Swal.fire({
            title: '',
            text: $.i18n._("cant_create_contractor_name_alias_cuz_no_contractor_selected"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

    showCantSaveAddressAliasContractorNotSelected() {
        Swal.fire({
            title: '',
            text: $.i18n._("cant_create_contractor_address_alias_cuz_no_contractor_selected"),
            ...this.defaultWarningInfoSwalSettings,
        });
    }

}
